<h2 mat-dialog-title mat-dialog-draggable-title>
  {{ "title.document_types" | translate }}
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>

<mat-divider></mat-divider>
<form
  name="form"
  action="#"
  #f="ngForm"
  (ngSubmit)="f.form.valid && selectDocumentType()"
  appFocusFirstElement
>
  <mat-dialog-content>
    <div class="row mt-3" id="myDiv">
      <!--      <div class="col-12 padding-input">-->

      <!--        <nz-tree-select-->
      <!--          style="-->
      <!--            font-family: Roboto;-->
      <!--            font-size: 16px;-->
      <!--          "-->
      <!--          [nzNodes]="dataTree"-->
      <!--          [nzShowSearch]="true"-->
      <!--          nzShowLine-->
      <!--          nzPlaceHolder="{{ 'search_form.search' | translate }}"-->
      <!--          [ngModelOptions]="{ standalone: true }"-->
      <!--          [(ngModel)]="documentTypeEnterpriseId"-->
      <!--          [nzNotFoundContent]="'autocomplete.suggestion' | translate"-->
      <!--          [nzHideUnMatched]="true"-->
      <!--          (input)="changeDataAnt($event)"-->
      <!--        >-->
      <!--        </nz-tree-select>-->
      <!--        -->
      <!--      </div>-->
      <div class="col-12" style="padding: 0px 12px !important;">
        <mat-form-field style="overflow: hidden">
          <mat-label>{{ 'form.doc_type_store_search' | translate }}</mat-label>
          <mat-select #enterpriseTypeSelect (focusout)="(checkFocus = true)"
                      (focus)="commonService.openComboBox(checkFocus, enterpriseTypeSelect);" id="focusSelect" name="type" #focusSelect
                      (selectionChange)=" checkFocus = false; onSelectionChange($event) ;" (click)="changeData()"
                      [(ngModel)]="selectedOption" #type="ngModel"
                      [ngClass]="{ 'is-invalid': f.submitted || type.invalid }" required>
            <mat-option>
              <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate" (input)="FilterData($event)" (click)="changeData()"
                                     [placeholderLabel]="'search_form.search' | translate"  [formControl]="searchCtrl">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let option of dataSelect" [value]="option.key"
                        (click)="this.commonService.closeDropdownList(this.enterpriseTypeSelect); checkDrop = false"
                        title="{{option.title}}">
              <i class="anticon mb-1 ant-tree-switcher-line-icon ng-tns-c31-60 anticon-file ng-star-inserted"
                 nz-icon="" nztype="file"><svg viewBox="64 64 896 896" fill="currentColor" width="1em" height="1em" class="ng-tns-c31-60" data-icon="file" aria-hidden="true"><path d="M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"></path></svg></i>
              <span class="ml-2 fix-width-input">{{option.title}}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </div>

  </mat-dialog-content>

  <mat-dialog-actions align="center" class="mt-2">
    <button appTrackEvent="w.btn.lap_hd_mau.huy_chon_mau"
      mat-stroked-button
      color="primary"
      class="mr-3"
      type="button"
      (click)="cancel()"
    >
      <mat-icon class="mr-0">cancel</mat-icon
      >{{ "enterprise_document_template_add_pop.buttons.cancel" | translate }}
    </button>
    <button appTrackEvent="w.btn.lap_hd_mau.luu_mau"
      #myButton
      id="myButton"
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="
        documentTypeEnterpriseId == '' || documentTypeEnterpriseId == null
      "
    >
      <mat-icon class="mr-0">save</mat-icon
      ><span *ngIf="!dataDialog.mode">{{
      "enterprise_document_template_add_pop.buttons.save" | translate
      }}</span>
      <span *ngIf="dataDialog.mode">{{
        "enterprise_document_template_add_pop.buttons.choose_template"
          | translate
        }}</span>
    </button>
  </mat-dialog-actions>
</form>
